import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Avatar, Table,  TableBody, TableCell, TableRow, Typography } from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
    clickable: {
      cursor: 'pointer',
    },
    [theme.breakpoints.up('sm')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 0,
            width: 948,
            verticalAlign: 'middle',
            borderBottom: 0,
        },
    },
    [theme.breakpoints.up('xs')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            verticalAlign: 'middle',
            borderBottom: 0,
        }
    },  
    genericLogo: {
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      borderBottomRightRadius: "10px",
      borderBottomLeftRadius: "10px",
      backgroundColor: theme.palette.nav.backgroundColor
    },  
    clickableGenericLogo: {
      cursor: 'pointer',
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      borderBottomRightRadius: "10px",
      borderBottomLeftRadius: "10px",
      backgroundColor: theme.palette.nav.backgroundColor
  
    }
});
/*
* This component displays app information from the app catalog.  It has the logo, app name and maybe SKU,
* and description formatted in a consistent fashion.
*/
class AppDisplay extends Component {

    getTitleLine = () => {
        let theTitleLine;

        if (this.props.displayForm === 'short') {
            theTitleLine = this.props.appName;
        } else {
            if (this.props.appName === this.props.appSku || this.props.appSku == null || this.props.appSku === '') {
                theTitleLine = this.props.appName;
            } else {
                theTitleLine = this.props.appName + " (" + this.props.appSku + ")";
            }
        }

        if (this.props.titleLimit) {
            if (theTitleLine.length > this.props.titleLimit) {
              // Find the space before that.
              let theSubstr = theTitleLine.substring(0, this.props.titleLimit);
              let lastSpaceIdx = theSubstr.lastIndexOf(' ');
              theTitleLine = theTitleLine.substring(0, lastSpaceIdx) + '...';
            }
        }        

        return theTitleLine;
    }

    getAvatarTitleLine = () => {
      let theTitleLine =  this.getTitleLine();
      if (theTitleLine != null && theTitleLine.length > 0) {
        return theTitleLine.substring(0,1);
      } else {
        return "";
      }

  }

    getDescription = () => {
        let theDescription = this.props.description;
        if (this.props.displayForm === 'short') {
            if (this.props.appSku != null && this.props.appSku !== '' && this.props.appName !== this.props.appSku) {
                theDescription = this.props.appSku;
            }
        }

        if (this.props.descriptionLimit) {
            if (theDescription.length > this.props.descriptionLimit) {
              // Find the space before that.
              let theSubstr = theDescription.substring(0, this.props.descriptionLimit);
              let lastSpaceIdx = theSubstr.lastIndexOf(' ');
              theDescription = theDescription.substring(0, lastSpaceIdx) + '...';
            }
        }        

        return theDescription;
    }

    goToAppEdit() {
      if (this.props.appId === null)
        return;
        
      let url = 'app?appId=' + this.props.appId

      if (this.props.fp !== null) {
        url = url + '&fp=' + this.props.fp;
      }
  
      this.props.history.push(`${url}`);
    }        

    render() {
        const classes = this.props.classes;
        return (
            <Table className='appbind-app' appid={this.props.appId || ''}>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.tblCellLogoCol}>
                            {this.props.appLogo == null && !this.props.appId &&
                                <Avatar height={"48px"} variant="rounded" className={classes.genericLogo}>{this.getAvatarTitleLine()}</Avatar>
                            }
                            {this.props.appLogo != null && !this.props.appId &&
                                <img alt="App" height="48px" className='appbind-app-logo' src={this.props.appLogo}/>
                            }
                            {this.props.appLogo == null && this.props.appId &&
                                <Avatar height={"48px"} variant="rounded" className={classes.clickableGenericLogo} onClick={() => {this.goToAppEdit()}}>{this.getAvatarTitleLine()}</Avatar>
                            }
                            {this.props.appLogo != null && this.props.appId &&
                                <img alt="App" height="48px" src={this.props.appLogo} onClick={() => {this.goToAppEdit()}} className={"appbind-app-logo " + classes.clickable}/>
                            }
                        </TableCell>
                        <TableCell className={classes.tblCellDescCol}>
                            <Typography className='appbind-app-title' variant="h6">{this.getTitleLine()}</Typography>
                            <Typography  className='appbind-app-description' variant="body2">{this.getDescription()}</Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

}
  
export default withStyles(styleSheet)(AppDisplay);